<template>
  <div>
    <table class="table mt-0 table-hover table-sm">
      <thead>
      <tr>
        <th></th>
        <th>ID</th>
        <th>Тип</th>
        <th>Доставка</th>
        <th>Комментарий</th>
        <th>Создание</th>
        <th>Препараты</th>
        <th>Статус</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(inv, i) in invoices">
        <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
        <td>{{ inv.id }}</td>
        <td><p><span :class="getTypeByInvoice(inv, 'type', true)">{{ getTypeByInvoice(inv, 'type') }}</span></p></td>
        <td>{{ printDate(inv.delivery_date) }}</td>
        <td>{{ inv.comment }}</td>
        <td>
          <!--          <UserName :id=""/>-->
          <p>{{ printDate(inv.created_at) }}</p>
        </td>
        <td>
          <p>препаратов: <strong>{{ +inv.totalDrugs }}</strong></p>
          <p>сумма: <strong>{{ Math.round(+inv.totalSum * 100) / 100 }}</strong></p>
        </td>
        <td><p><span :class="getTypeByInvoice(inv, 'status',true)">{{ getTypeByInvoice(inv, 'status') }}</span></p></td>
        <td>
          <button @click="showInvoice(inv)" class="btn btn-xs btn-info">
            <i class="icon-fa icon-fa-eye"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import UserName from "@/components/users/UserName.vue";

export default {
  props: ['invoices', 'paginator'],
  components: {
    UserName,
  },
  data() {
    return {
      invoiceTypes: {
        1: {title: 'поступление', class: 'badge badge-success'},
        2: {title: 'транзит', class: 'badge badge-info'},
        3: {title: 'списание', class: 'badge badge-warning'},
        4: {title: 'заказ', class: 'badge badge-success'},
      },
      invoiceStatuses: {
        1: {title: 'предварительная', class: 'badge badge-dark'},
        2: {title: 'в дороге', class: 'badge badge-info'},
        0: {title: 'доставлена', class: 'badge badge-success'},
        3: {title: 'модерация', class: 'badge badge-info'},
        4: {title: 'сборка', class: 'badge badge-info'},
      },
    }
  },
  methods: {
    getTypeByInvoice(invoice, type, className = false) {
      switch (type) {
        case 'type':
          return className ? this.invoiceTypes[invoice.type].class : this.invoiceTypes[invoice.type].title;
        case 'status':
          return className ? this.invoiceStatuses[invoice.status].class : this.invoiceStatuses[invoice.status].title;

      }
      return;
    },
    showInvoice(invoice) {
      if (invoice.type === 4) {
        this.$store.dispatch('platform/setGlobalDrawerData', {
          data: {type: 'editOrderInvoice', invoiceId: invoice.id},
          // callBackAction: () => this.getRecords()
        });
      } else {
        this.$store.dispatch('platform/setGlobalDrawerData', {
          data: {type: 'editInvoice', invoiceId: invoice.id},
          // callBackAction: () => this.getRecords()
        });
      }
    },
  }
}

</script>
